import { FaCheck } from "react-icons/fa6";

const Checkbox = ({
  id,
  label,
  checkedItems,
  onChange,
  disabled,
  isFullWidth,
  isSmall,
}: any) => {
  const isChecked = checkedItems.includes(id);

  const handleInputChange = () => {
    if (!disabled && onChange) {
      onChange(id);
    }
  };

  return (
    <div
      className={`flex gap-2 items-start border-[1px] border-gray-600 bg-white mb-1 ${
        isSmall ? "p-2" : "p-4"
      } min-w-[250px] ${isFullWidth ? "w-full" : "w-max"} rounded-lg ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <div className="grid place-items-center mt-[3px] relative">
        <input
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleInputChange}
          disabled={disabled}
          className={`peer col-start-1 row-start-1 appearance-none shrink-0 w-4 h-4 border-2 border-slate-300 bg-slate-300 rounded-[4px] focus:outline-none disabled:border-gray-400 ${
            disabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        />
        <div className="duration-200 pointer-events-none col-start-1 row-start-1 w-4 h-4 rounded-[4px] peer-checked:bg-slate-400 peer-checked:peer-disabled:bg-gray-400" />
        <div className="duration-200 pointer-events-none col-start-1 row-start-1 w-2 h-2 flex justify-center items-center opacity-0 peer-checked:opacity-100 text-white">
          <FaCheck />
        </div>
      </div>
      <label
        htmlFor={id}
        className={`${isSmall ? "text-xs" : "text-sm"} ${
          isSmall ? "mt-[2px]" : "mt-0"
        } font-bold text-start ${
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
